import * as runtime from '@/api/runtime'
import {
  DeleteCollectionListRequest,
  DeleteCollectionListRequestToJSON,
  GetCollectionListDetailRequest,
  GetCollectionListDetailRequestToJSON,
  CreateCollectionListRequest,
  CreateCollectionListRequestToJSON,
  CollectionList,
  CollectionListFromJSON,
  CollectionListDetail,
  CollectionListDetailFromJSON,
  SearchCollectionListRequest,
  SearchCollectionListRequestToJSON,
  UpdateCollectionListRequest,
  UpdateCollectionListRequestToJSON,
  GetCollectionListBibliographyInfoRequestToJSON,
  GetCollectionListBibliographyInfoRequest,
  CollectionListBibliographyInfo,
  CollectionListBibliographyInfoFromJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'

export class CollectionListApi extends runtime.BaseAPI {
  /**
   * 資料リストを検索する
   * 資料リスト検索
   */
  async searchCollectionList(
    request: SearchCollectionListRequest
  ): Promise<CollectionList[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchCollectionListRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/collection-list/search',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(CollectionListFromJSON)
    ).value()
  }

  /**
   * 資料リスト詳細を取得する
   * 資料リスト詳細取得
   */
  async getCollectionListDetail(
    request: GetCollectionListDetailRequest
  ): Promise<CollectionListDetail> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetCollectionListDetailRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/collection-list/${queryParameters?.id ?? ''}`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      CollectionListDetailFromJSON(jsonValue)
    ).value()
  }

  /**
   * 資料リストを削除する
   * 資料リスト削除
   */
  async deleteCollectionList(
    request: DeleteCollectionListRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteCollectionListRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/collection-list/${bodyParameters?.id ?? ''}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料リストを作成する
   * 資料リスト作成
   */
  async createCollectionList(
    request: CreateCollectionListRequest
  ): Promise<number> {
    const bodyParameters: runtime.HTTPBody = CreateCollectionListRequestToJSON(
      request
    )
    const response = await this.requestPost('/collection-list', bodyParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.collection_list_id)
    ).value()
  }

  /**
   * 資料リストを更新する
   * 資料リスト更新
   */
  async updateCollectionList(
    request: UpdateCollectionListRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateCollectionListRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/collection-list/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料リスト書誌情報を取得する
   * 資料リスト書誌情報取得
   */
  async getCollectionListBibliographyInfos(
    request: GetCollectionListBibliographyInfoRequest
  ): Promise<CollectionListBibliographyInfo[]> {
    const bodyParameters: runtime.HTTPBody = GetCollectionListBibliographyInfoRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/collection-list/bibliography-real',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(CollectionListBibliographyInfoFromJSON)
    ).value()
  }
}
